import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { tap, takeUntil, map, shareReplay } from 'rxjs/operators';
import { PageName } from '@app/constants';
import { DataService } from '@app/data';

@Component({
  selector: 'app-search',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.less']
})
export class SearchComponent {

  public currentTaxonomyPage$ = this.data.currentTaxonomyPage$;
  public page: any = this.data.getCurrentPage();
  public pageName: PageName = this.page.pageName;
  public class: string = this.page.section;
  public queryParams$ = this.data.queryParams$.pipe(shareReplay({ bufferSize: 1, refCount: true }));
 
  constructor(
    private data: DataService
  ) {}
}
